import Paragraph from "../components/paragraph/Paragraph";
import { useReveal } from "../hooks/useReveal";
import { trim } from "../utils/trim";

const AUDIENCE_ITEMS = [
  "Znaš šta želiš da promeniš, ali ne znaš kako da tu promenu kreiraš.",
  "Tek počinješ da radiš na sebi i potreban ti je jasan pravac.",
  "Mnogo toga razumeš u teoriji, ali ti nedostaju konkretni koraci za primenu.",
  "Želiš da bolje razumeš svoje misli, emocije, navike i reakcije.",
  "Privlače te neurobiologija, psihologija i duhovnost, ali želiš znanje predstavljeno jasno, praktično i razumljivo.",
];

const CheckIcon = () => (
  <svg
    className="target-audience_check"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
  >
    <path
      d="M4 10.5 8 14.5 16 5.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TargetAudience = () => {
  const { ref, isVisible } = useReveal();

  return (
    <div
      ref={ref}
      className={trim(`target-audience reveal ${isVisible ? "is-visible" : ""}`)}
    >
      <div
        className="target-audience_head reveal-child"
        style={{ ["--reveal-delay" as string]: "0ms" }}
      >
        <h2 className="section-title target-audience_title">
          Za koga je NeoUm Media?
        </h2>
        <Paragraph
          variant="p1"
          className="text-muted target-audience_intro u-color-secondary-500"
        >
          NeoUm Media je namenjena tebi ako:
        </Paragraph>
      </div>
      <ul className="target-audience_list">
        {AUDIENCE_ITEMS.map((item, index) => (
          <li
            key={item}
            className="target-audience_item reveal-child"
            style={{ ["--reveal-delay" as string]: `${120 + index * 70}ms` }}
          >
            <CheckIcon />
            <span>{item}</span>
          </li>
        ))}
      </ul>
      <div
        className="reveal-child"
        style={{
          ["--reveal-delay" as string]: `${120 + AUDIENCE_ITEMS.length * 70}ms`,
        }}
      >
        <Paragraph variant="p2" className="text-muted target-audience_note">
          Ne moraš biti stručnjak niti imati prethodno iskustvo. Platforma je
          osmišljena tako da ti pomogne da postepeno razumeš sebe, povežeš znanje
          sa sopstvenim životom i počneš da ga primenjuješ.
        </Paragraph>
      </div>
    </div>
  );
};

export default TargetAudience;
